import React, { useEffect, useState } from "react";
import Formacion1 from "../alineaciones/Formacion1";
import Slider from "react-slick";
import { fetchAuspiciantes } from "../action/AuspicianteActions";
import { fetchAuspiciantes2 } from "../action/AuspicianteActions2";
import "../App.css";
import GraficosVotaciones from "../componentes.home/GraficosVotaciones";
import SolidButton from "../componentes/buttons/SolidButton";
import ContactoHome2 from "./ContactoHome2";
import { useDispatch, useSelector } from "react-redux";
import TablaComponent from "../componentes.home/TablaComponent";
import { Link } from "react-router-dom";
import { Auspiciantes } from "../componentes.home/Auspiciantes";
import { 
  SkeletonCarousel, 
  SkeletonContact 
} from "../componentes/Skeleton";

function Home2(props) {
  const [loadingContact, setLoadingContact] = useState(true);
  const config_server = JSON.parse(localStorage.getItem("configServer"));
  const dispatch = useDispatch();
  const auspiciantes = useSelector((state) => state.auspiciantes);
  const auspiciantes2 = useSelector((state) => state.auspiciantes2);
  const encuentros = useSelector((state) => state.products);

  // const { ciudad } = props.match.params || { ciudad: "Asuncion" };
  let ciudad;
  let targetUri = "";
  if (props.match.params && props.match.params.ciudad) {
    ciudad = props.match.params.ciudad;
  } else {
    ciudad = "ASUNCION";
    targetUri = "ciudad/";
  }

  useEffect(() => {
    const loadAuspiciantes = () => dispatch(fetchAuspiciantes(ciudad));
    loadAuspiciantes();
    
    const loadAuspiciantes2 = () => dispatch(fetchAuspiciantes2(ciudad));
    loadAuspiciantes2();
    
    // Simular carga de contacto
    const contactTimer = setTimeout(() => {
      setLoadingContact(false);
    }, 2000);
    
    return () => {
      clearTimeout(contactTimer);
    };
  }, [dispatch, ciudad]);
  const config = {
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: -3,
    cssEase: "linear",
    arrows: false,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: -3,
          infinite: true,
          dots: false,
          autoplay: true,
          speed: 1000,
          autoplaySpeed: 2000,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: -3,
          infinite: true,
          dots: false,
          autoplay: true,
          speed: 1000,
          autoplaySpeed: 2000,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: -3,
          infinite: true,
          dots: false,
          autoplay: true,
          speed: 1000,
          autoplaySpeed: 2000,
        },
      },
    ],
  };
  const config2 = {
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    cssEase: "linear",
    arrows: false,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
          autoplay: true,
          speed: 1000,
          autoplaySpeed: 2000,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
          autoplay: true,
          speed: 1000,
          autoplaySpeed: 2000,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
          autoplay: true,
          speed: 1000,
          autoplaySpeed: 2000,
        },
      },
    ],
  };
  const graficos = () => {
    return (
      <div className="graficos">
        <GraficosVotaciones />
      </div>
    );
  };
  const settings2 = config2;
  const settings = config;
  console.log("ffff", encuentros.items);
  return (
    <React.Fragment>
      <br />
      <Auspiciantes ciudad={ciudad} />

      {/* <TablaComponent /> */}

      <h1 className="h3 centrar" style={{ marginTop: "3.5rem !important" }}>
        {"Catálogos de " + ciudad}
      </h1>

      <div id="califica">
        <Formacion1 ciudad={ciudad} targetUri={targetUri} />
      </div>

      <div id="graficos">
        {!auspiciantes.items ? (
          <SkeletonCarousel />
        ) : (
          <Slider
            {...settings2}
            aria-hidden="true"
            style={{ marginTop: "5rem", marginBottom: "2rem" }}
          >
            {auspiciantes.items.map((auspiciante) => {
              console.log(auspiciante);
              return (
                <Link
                  key={auspiciante.id_auspiciante}
                  target="_blanck"
                  to={{ pathname: auspiciante.webpage_auspiciante }}
                >
                  <img
                    key={auspiciante.id_auspiciante}
                    src={`${config_server.linkImageAuspiciante}${auspiciante.imagen_auspiciante}`}
                    className="img-auspiciantes"
                    alt="Emprendimientos virtuales sa"
                  />
                </Link>
              );
            })}
          </Slider>
        )}
        {!auspiciantes2.items ? (
          <SkeletonCarousel />
        ) : (
          <Slider
            {...settings}
            aria-hidden="true"
            style={{ marginTop: "2rem", marginBottom: "7rem" }}
          >
            {auspiciantes2.items.map((auspiciante) => {
              return (
                <Link
                  key={auspiciante.id_auspiciante}
                  target="_blanck"
                  to={{ pathname: auspiciante.webpage_auspiciante }}
                >
                  <img
                    key={auspiciante.id_auspiciante}
                    src={`${config_server.linkImageAuspiciante}${auspiciante.imagen_auspiciante}`}
                    className="img-auspiciantes"
                    alt="Emprendimientos virtuales sa"
                  />
                </Link>
              );
            })}
          </Slider>
        )}

        <br />
        <br />
      </div>
      {/* {graficos()} */}

      <br />
      <br />
      <br />
      <br />

      <br />
      <div>
        <div id="contacto">
          {loadingContact ? (
            <SkeletonContact />
          ) : (
            <ContactoHome2 />
          )}
        </div>
      </div>
    </React.Fragment>
  );
}

export default Home2;
